import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Space, message, Tag, Switch } from "antd";
import axiosHttp from "../../appRedux/services/axiosCommon";


const DomainList = () => {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDomains = async () => {
    setLoading(true);
    try {
      const res = await axiosHttp.get("/api/v3/admin/domains");
      if (res.data?.success) {
        setDomains(res.data.data);
      }
    } catch (error) {
      message.error("Failed to fetch domains");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDomains();
  }, []);


  const handleDemote = async (id) => {
    try {
      const res = await axiosHttp.post(`/api/v3/admin/domains/${id}/demote`);
      if (res.data?.success) {
        message.success("Domain demoted back to regular category");
        fetchDomains();
      }
    } catch (error) {
      message.error("Failed to demote domain");
    }
  };

  const handleFeaturedToggle = async (id, checked) => {
    try {
      const res = await axiosHttp.put(`/api/v3/admin/domains/${id}`, { is_featured: checked });
      if (res.data?.success) {
        message.success(`Domain marked as ${checked ? 'Featured' : 'Not Featured'}`);
        fetchDomains();
      }
    } catch (error) {
      message.error("Failed to update featured status");
    }
  };

  const columns = [
    {
      title: "Domain Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <Link to={`/domains/builder/${record._id}`}><strong>{text}</strong></Link>,
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
    },
    {
      title: "Priority (Rank)",
      dataIndex: "domain_priority",
      key: "domain_priority",
      sorter: (a, b) => a.domain_priority - b.domain_priority,
    },
    {
      title: "Mapped Topics",
      dataIndex: "skillCount",
      key: "skillCount",
      render: (count) => <Tag color="blue">{count} Topics</Tag>
    },
    {
      title: "Featured",
      dataIndex: "is_featured",
      key: "is_featured",
      render: (is_featured, record) => (
        <Switch 
          checked={is_featured} 
          onChange={(checked) => handleFeaturedToggle(record._id, checked)} 
        />
      )
    },
    {
      title: "Promoted to Explore",
      dataIndex: "is_promoted",
      key: "is_promoted",
      render: (is_promoted) => is_promoted ? <Tag color="green">Yes</Tag> : <Tag color="default">No</Tag>
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/domains/builder/${record._id}`}>
            <Button type="primary" size="small">Builder</Button>
          </Link>
          <Button danger size="small" onClick={() => handleDemote(record._id)}>
            Demote
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="row m-0 mt-3">
      <div className="col-md-12 p-0" id="table-responsive">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4>Manage Domains</h4>
        </div>
        <div className="table-responsive" id="setMinheight">
          <Table
            className="table-striped"
            columns={columns}
            dataSource={domains}
            rowKey="_id"
            loading={loading}
            pagination={{ pageSize: 20 }}
            scroll={{ x: "max-content" }}
          />
        </div>
      </div>
    </div>
  );
};

export default DomainList;
